<template>
  <div>
    <BlockHead />
    <BlockHowItWork />
    <BlockAchievments />
    <BlockWhyBimlib />
    <BlockWhatWeDid />
    <!-- <BlockReview /> -->
    <BlockLeaveApplication />
  </div>
</template>

<script>
import BlockHead from './components/BlockHead'
import BlockHowItWork from './components/BlockHowItWork'
import BlockAchievments from './components/BlockAchievments'
import BlockWhyBimlib from './components/BlockWhyBimlib'
import BlockWhatWeDid from './components/BlockWhatWeDid'
// import BlockReview from './components/BlockReview'
import BlockLeaveApplication from './components/BlockLeaveApplication'
export default {
  name: "landing-partnerka",
  components: {
    BlockHead,
    BlockHowItWork,
    BlockAchievments,
    BlockWhyBimlib,
    BlockWhatWeDid,
    // BlockReview,
    BlockLeaveApplication,
  },
  data() {
    return {
      showModal: false,
    }
  },
  props: {
    user_info: Object,
  },
  provide() {
    return {
      user_info: this.user_info,
      getImgPath(img) {
        return `/dist/assets/front_white/img/landing__partnerka/${img}`
      },
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
::v-deep {
  .primary-color {
    color: $primary-color;
  }
  .text-center {
    text-align: center;
  }
}
</style>
